import { observer } from 'mobx-react-lite'

import { useValueContext } from 'contexts'
import { isBeforeCurrent, isValidDate } from 'utils'

export const CurrentDateError = observer(() => {
  const { eventStore } = useValueContext()
  const { event } = eventStore

  if (!event) {
    return null
  }

  const hasError = !isBeforeCurrent(event?.startTime)

  if (!isValidDate(event?.startTime)) {
    return <div className="error">Введите корректную дату</div>
  }

  return hasError && <div className="error">Дата начала не может быть в будущем</div>
})
